/**
 * User ConversationsHub - now simply imports the unified component
 */
import ConversationsHub from "../../Conversations/convoHub";

export default ConversationsHub;